"use client";

import { RiCalendarEventLine } from "@remixicon/react";
import { memo, useCallback } from "react";
import { t } from "@/utils";
import { HmcInputField } from "@/components/hmc-on-server";
import { useController, useFormContext } from "react-hook-form";
import { debounce } from "@/utils";

type FormDateProps = {
	readonly [key: string]: any;
	readonly hasError: boolean;
	readonly label: string;
	readonly field: string;
	readonly value?: string;
	readonly isRequired?: boolean;
};

/**
 * Date form field
 * @constructor
 */
function FormDate(props: FormDateProps) {
	const { control } = useFormContext();
	const { field } = useController({
		control,
		name: props.field,
		rules: { required: Boolean(props.isRequired) },
	});

	const onChange = useCallback(
		({ detail: { value } }: { detail: { value: string } }) => {
			field.onChange(value);
		},
		[field]
	);

	const debouncedOnChange = debounce(onChange, 500);

	return (
		<HmcInputField
			isFullWidth
			isClearable
			fieldType="date"
			status={props.hasError ? "error" : null}
			helperText={
				props.hasError
					? t("pages.cms.required-field", {
							field: props.label,
						})
					: null
			}
			onHmcInput={debouncedOnChange}
			{...props}
			value={props.value}
		>
			<RiCalendarEventLine
				size={24}
				// @ts-expect-error: "slot" doesn't exist on this component
				slot="prefix"
			/>
		</HmcInputField>
	);
}

export default memo(FormDate);
